<template>
  <div class="help-center-post-tree__component">
    <template
      v-for="category in categories"
      :key="category.id"
    >
      <HelpCenterPostTreeCards
        v-if="category.cards"
        :category="category"
      />
      <div v-else>
        <HelpCenterPostTreeHeading
          :nested="nested"
          :category="category"
        />
        <HelpCenterPostTree
          v-if="category.categories"
          class="help-center-post-tree__branch"
          nested
          :post-map="postMap"
          :categories="category.categories"
        />
        <template v-else-if="category.posts">
          <div class="help-center-post-tree__hr" />
          <HelpCenterPostTreeLeaves
            :nested="nested"
            :category="category"
            :post-map="postMap"
            :has-siblings="hasSiblings"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterPostTreeCards from 'help-center/components/HelpCenterPostTreeCards'
import HelpCenterPostTreeLeaves from 'help-center/components/HelpCenterPostTreeLeaves'
import HelpCenterPostTreeHeading from 'help-center/components/HelpCenterPostTreeHeading'

const props = defineProps({
  nested: {
    type: Boolean
  },
  postMap: {
    type: Object,
    required: true
  },
  categories: {
    type: Array,
    required: true
  }
})

const hasSiblings = computed(() => {
  return props.categories.length > 1
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-tree {
  &__component {
    gap: 32px;
    display: flex;
    flex-direction: column;

    @include help-center-breakpoint(md) {
      gap: 48px;
    }
  }

  &__branch {
    display: grid;
    row-gap: 24px;
    margin-top: 24px;
    column-gap: 64px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;

    @include help-center-breakpoint(sm) {
      grid-template-columns: 1fr 1fr;
    }

    @include help-center-breakpoint(md) {
      row-gap: 48px;
      margin-top: 32px;
    }
  }

  &__hr {
    @include help-center-hr;
    margin: $helpCenterMobileVerPadding 0;

    @include help-center-breakpoint(md) {
      margin: 16px 0;
    }
  }
}
</style>
